import React, { useState, useEffect, useCallback } from "react"
import { useParams } from "react-router-dom"
import { X } from "lucide-react"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, cn } from "lib/utils"
import { ElementEditorWrapper } from "lib/components"
// import TrxHistoryTableRender from "./TrxHistoryTableRender"
import { trx_history_data } from "./trx_history_data"

const { widths, columns, data } = trx_history_data

export default function TrxHistoryTableEditor({ }: { }){

  const { tmplid } = useParams()
  const { store, AppStore }:any = appStore()

  const { data:_Template } = queryTools.resource.parseQueryForApi("template.findById", { _id: tmplid })
  const { data:_Elements } = queryTools.resource.parseQueryForApi("statement.findAll", {})

  const [ elementsAvailable, setElementsAvailable ] = useState<any[]>([])
  const [ selectedElement, setSelectedElement ] = useState<any>(null)
  const [ showEditor, setShowEditor ] = useState<boolean>(false)

  const handleLoaderSelect = (elem:any) => {
    console.log(elem)
    setSelectedElement(elem)
  }

  useEffect(() => {
    const client_id = _Template?.AssignedTo?._id || null
    if( _Elements ) setElementsAvailable(_Elements.filter((elem:any) => elem.element_type === store.element.refstr && (elem.client_id === null || elem.client_id === client_id)))
  },[_Elements])

  return (
    <div className="w-full grid grid-cols-12 mt-4 border border-solid border-neutral-700 p-2">
      { columns.map( (col:any, idx:number) => (
        <div key={col.id} className={cn("whitespace-nowrap font-bold text-xs uppercase", widths[idx])}>{col.label}</div>
      ))}

      <div className="w-full col-span-12 border-t border-solid border-neutral-700"></div>

      { data.map( (item:any) => Object.values(item).map( (value:any, idx:number) => (
        <div key={idx} className={cn("whitespace-nowrap", widths[idx] )}>{value}</div>
      )))}
    </div>
  )
}